import React, {Component, useState,useEffect, useMemo} from 'react';
import CheckboxTree from 'react-checkbox-tree';
import 'react-checkbox-tree/lib/react-checkbox-tree.css';
import {useProductCategory} from '../../queries/productCategory';
import {PRODUCTS_COUNT} from '../../queries/productsCount';
import ReactDOM from 'react-dom';
import {DebounceInput} from 'react-debounce-input';
import {useLazyQuery, gql} from "@apollo/client";
import {PRODUCT_SEARCH} from './../../queries/productSearch';
import {PRODUCT_ALL} from './../../queries/productAll';
import axios from 'axios';
import InfinitProgressBar from '../../components/InfiniteProgressBar';
import ImportantSalesLinks from '../../components/ImportantSalesLinks';
import { combineLatest, of, from } from 'rxjs';
import { map, pluck } from 'rxjs/operators';

const SidebarForProduct = (props) => {

const [checked, setChecked] = useState([]);
const [expanded, setExpanded] = useState([]);
const [productSearch, productData] = useLazyQuery(PRODUCT_SEARCH, {
    variables: { searchText: `{ from:${(props.productPagination.currentPage - 1) * props.productPagination.productsPerPage}, size:${props.productPagination.productsPerPage}, culture: "fa-ir", fulltext: "${props.productPagination.searchText} ${checked.length > 0 ? checked.map(i => 'C' + i).toString().replaceAll(',',' ') : ""}"}` , skip: (props.productPagination.currentPage - 1) * props.productPagination.productsPerPage, first: props.productPagination.productsPerPage }
  });
  const [productsCount, productsCountData] = useLazyQuery(PRODUCTS_COUNT);

  const [productAll, productAllData] = useLazyQuery(PRODUCT_ALL, {
    variables: { skip: (props.productPagination.currentPage - 1) * props.productPagination.productsPerPage, first: props.productPagination.productsPerPage }
  });
  
const searchHandler = (e) => {    
    props.searchPhraseSetter(e.target.value ? `${e.target.value}` : "");  
    props.currentPageSetter(1);  
  };
 

  useEffect(() => {
    props.productPagination.currentPage = props.currentPage;
    props.checkedSetter(checked)
    const s = `${props.searchPhrase} ${checked.length > 0 ? checked.map(i => 'C' + i).toString().replaceAll(',',' ') : ""}`;
    if (s && s.trim()) {
        props.productPaginationSetter({products: ( []), currentPage: props.currentPage, productsPerPage: 6, searchText: s });
        combineLatest([axios({
            url:`/api/queries/searchProduct?parameters={"from" :${0}, "size" : ${1}, culture: "fa-ir" , "fulltext" :  "${s}"}`,
            method:"get"
        }),
        from(productSearch()).pipe(pluck("data"))
    
    ]).subscribe(x => {
       
        props.productPaginationSetter({products: (x[1] && x[1].searchProduct ? x[1].searchProduct : []), currentPage: props.currentPage, productsPerPage: 6, searchText: s, total: x[0] && x[0].data ? x[0].data.count : 0 })
       });
        
    } else {
        combineLatest([from(productsCount()),
        from(productAll()).pipe(pluck("data"))
    
    ]).subscribe(x => {
        console.log(x[1]);
        props.productPaginationSetter({products: (x[1] && x[1].product ? x[1].product : []), currentPage: props.currentPage, productsPerPage: 6, searchText: "", total: x[0] && x[0].data ? x[0].data.productsCount[0].productCount : 0 })
        });
       
    }
    
  }, [checked, props.searchPhrase, props.currentPage])

   
  const {error, loading, data} = useProductCategory();
      if(loading) return <InfinitProgressBar/>
    if(error) return <div>error!</div>
    const result = data.productCategory;
    const ProductCategoryData = result.filter(x => x.id === 1 || x.id === 2 || x.id === 9).map(x => new Object({
        value: x.id,
        alias: x.alias,
        label: x.displayText,
        children: x.childrenCategories.contentItems ? x.childrenCategories.contentItems.map(y => new Object({
            value: y.id,
            alias: x.alias,
            label: y.displayText,
            children: y.childrenCategories ? y.childrenCategories.contentItems.map(z => new Object({
                value: z.id,
                alias: x.alias,
                label: z.displayText
            })) : null
        })) : null
    }));
    
    
     

      return (
        <div style={{width:'355px', height:"100%", display:'flex', flexDirection:'column'}} >
            <div style={{width:'100%', height:"auto", display:'flex', flexDirection:'column'}}>
                <p>جستجوی محصول:</p>
                <DebounceInput
          minLength={1}
          debounceTimeout={300} 
                style={{width:'70%', height:"40px", padding:'2%', border:'ipx solid lightgray', borderRadius:'20px', outline:'none'}} 
                onChange={(e) => searchHandler(e)}
                
                />
            </div>
            <br/>
            <hr style={{width:'100%', height:"2px", color:"#e5e5e5", backgroundColor:'#e5e5e5'}}/>
            <CheckboxTree
                nodes={ProductCategoryData}
                direction="rtl"
                iconsClass="fa5"
                checked={checked}
                expanded={expanded}
                onCheck={checked => {
                    props.currentPageSetter(1);                   
                    setChecked( checked );
                }}
                onExpand={expanded => setExpanded( expanded )}
                icons={{
                    check: <span className="rct-icon rct-icon-check" />,
                    uncheck: <span className="rct-icon rct-icon-uncheck" />,
                    halfCheck: <span className="rct-icon rct-icon-half-check" />,
                    expandClose: <span className="rct-icon rct-icon-expand-close" />,
                    expandOpen: <span className="rct-icon rct-icon-expand-open" />,
                    expandAll: <span className="rct-icon rct-icon-expand-all" />,
                    collapseAll: <span className="rct-icon rct-icon-collapse-all" />,
                    parentClose: null,
                    parentOpen: null,
                    leaf: null,
                }}
                
            />
            <hr style={{width:'100%', height:"2px", color:"#e5e5e5", backgroundColor:'#e5e5e5'}}/>
            <ImportantSalesLinks />
        </div>
    );
}



export default SidebarForProduct;
